<template>
  <div class="loader" :class="{'loader__fill': fill}">
    <ul class="dots">
      <li class="dot"></li>
      <li class="dot"></li>
      <li class="dot"></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    fill: Boolean,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.loader {
  position: relative;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  &__fill {
    min-height: calc(100vh - 300px);
    align-items: center;
  }
}

.dots {
  display: flex;
}

.dot {
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin: 2px;
  animation: dotDance 1.5s infinite ease-in-out;
  background: var(--color-dark);
  &:nth-child(2) {
    animation-delay: -0.16s;
  }
  &:nth-child(3) {
    animation-delay: -0.32s;
  }
}

@keyframes dotDance {
  0%, 80%, 100% {
    transform: scale(1);
  }
  40% {
    transform: scale(0.5);
  }
}
</style>
